// export const BotServicePath = process.env.REACT_APP_BOT_SERVICE_PATH as string;
// export const BotWsPath = process.env.REACT_APP_BOT_WS_PATH as string;
export const BotServicePath = "https://bot.dentagenix.com"
export const BotWsPath = "wss://bot.dentagenix.com"
